import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CardModule } from 'primeng/card';
import { ProductListComponent } from '../product-list/product-list.component';
import { ResourceListComponent } from '../resource-list/resource-list.component';

@Component({
  selector: 'lib-home-container',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    CommonModule,
    CardModule,
    FontAwesomeModule,
    ProductListComponent,
    ResourceListComponent,
  ],
})
export class HomeComponent {}
